export default "__VITE_ASSET__crN7F$28__"